var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showLoading)?_c('v-overlay',{attrs:{"color":"#f1f1f1"}},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"size":64,"indeterminate":"","color":"primary"}})],1)],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }